var _rect, _path, _path2, _g, _use, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmazonS3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 512,
    rx: "15%",
    width: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m259.7 348.2-137 32.7v-250.3l137 32z",
    fill: "#e05243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 348.6 133.3 32.3.1-.3v-249.6l-.1-.3-133.3 32.3v185.7",
    fill: "#8c3123"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e05243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m256 64v96.8l58 14.4v-82.2zm133.3 66.6v250.3l25.6-12.8v-224.7zm-133.3 77.1v97l58-7.5v-82.2zm58 129.1-58 14.4v96.8l58-29z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#8c3123",
    transform: "matrix(-1 0 0 -1 512 512)",
    xlinkHref: "#a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m314 175.2-58 10.7-58-10.7 57.9-15.1 58.3 15.1",
    fill: "#5e1f18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m314 336.8-58-10.7-58 10.7 57.9 16.1 58.3-16.1",
    fill: "#f2b0a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon-s3.accdd47d177085fff2f6ca7311866e6e.svg";
export { ForwardRef as ReactComponent };